import src from "IMAGE";
export default { src, width: 331, height: 40, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAE/WGkGO1FiLzE0SSoqKzwUMT1GASk5OgEsPj4BIC0sbVYGFj+IhFIAAAAASUVORK5CYII="};
